import { boolean, command, flag } from 'cmd-ts';
import {
  INITIALIZATION_FAILED,
  INITIALIZATION_SUCCESS,
  REMOVING_FAILED,
  REMOVING_SUCCESS,
} from '../constants';
import { removeConfig, writeConfig } from './cli.utils';

export const cli = command({
  name: 'cli-test',
  description: `Generate a setup file for cli testing`,
  version: '0.0.1',
  args: {
    init: flag({
      description: 'init',
      short: 'i',
      type: boolean,
      long: 'init',
    }),

    remove: flag({
      description: 'remove',
      short: 'r',
      type: boolean,
      long: 'remove',
    }),
  },
  handler: async ({ init, remove }) => {
    const l = console.log;

    if (init) {
      return writeConfig()
        .then(() => l(INITIALIZATION_SUCCESS))
        .catch(() => l(INITIALIZATION_FAILED));
    }

    if (remove) {
      return removeConfig()
        .then(() => l(REMOVING_SUCCESS))
        .catch(() => l(REMOVING_FAILED));
    }
  },
});
